import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { SpinnerService } from '../../../../../services/spinner/spinner.service';
import { StoreService } from '../../../../../services/api-store/store/store.service';
import { UtilsService } from '../../../../../services/utils-folder/utils.service';
import { HttpErrorResponse } from '@angular/common/http';
import { StoreRequest } from '../../../../../models/api-store/store/store.request.model';
import { OpeningClosingHoursService } from '../../../../../services/api-store/opening-closing-hours/opening-closing-hours.service';
import { LocationStore } from '../../../../../models/api-store/location-store/location-store.model';
import { EmbeddedStoreManager } from '../../../../../models/api-store/embedded-store-manager/embeddedStoreManager.model';
import { VisibilityFlag } from '../../../../../models/api-store/visibility-flag/visibility-flag.model';
import { OpeningClosingHoursRequestSearch, OpeningClosingHoursType } from '../../../../../models/api-store/opening-closing-hours/opening-closing-hours.request.model';
import { OpeningClosingHoursResponse } from '../../../../../models/api-store/opening-closing-hours/opening-closing-hours.response.model';
import { GalleryService } from '../../../../../services/api-dam/gallery/gallery.service';
import { GalleryRequestSearch } from '../../../../../models/api-dam/gallery/gallery-request.model';
import { StoreAccessoryService } from '../../../../../services/api-store/store-accessory/store-accessory.service';
import { StoreAccessoryRequestSearch } from '../../../../../models/api-store/store-accessory/store-accessory.request.model';
import { ProductServiceService } from '../../../../../services/api-store/product-service/product-service.service';
import { PromotionEventService } from '../../../../../services/api-store/promotion-event/promotion-event.service';
import { ProductServiceRequestSearch } from '../../../../../models/api-store/product-service/product-service.request.model';
import { PromotionEventRequestSearch } from '../../../../../models/api-store/promotion-event/promotion-event.request.model';
import { ImmaginiCreateComponent } from '../../../dam/immagini/immagini-create/immagini-create.component';
import { LoadImageFromDamComponent } from '../../../../../components/ui/load-image-from-dam/load-image-from-dam.component';
import { ImageResponseGet } from '../../../../../models/api-dam/image/image-response.model';
import { ImageService } from '../../../../../services/api-dam/image/image.service';
import { DocumentService } from '../../../../../services/api-dam/document/document.service';
import { DocumentRequestSearch } from '../../../../../models/api-dam/document/document-request.model';
import { RouteExtService } from '../../../../../helpers/route-ext';
import { environment } from '../../../../../../environments/environment';
import { ChoicePositionmapModalComponent } from '../../../../ui/choice-positionmap-modal/choice-positionmap-modal.component';
import { DIALOG_LARGE_CONFIG } from '../../../../../utils/config/modal-settings';
import { LOADINGIMAGE } from '../../../../../utils/config/image-settings';
import { FALSE, TRUE } from '../../../../../utils/config/const';

@Component({
  selector: 'app-store-edit',
  templateUrl: './store-edit.component.html',
  styleUrls: ['./store-edit.component.css']
})
export class StoreEditComponent implements OnInit {

  id: number;
  titleStore: string = "";
  pageUrl: string = "";
  fe_url: string = environment.frontendEnv.url;
  formBuilder: FormGroup;
  tabs: any = {
    store: "active",
    location: "",
    storemanager: "",
    flags: ""
  };
  request: any = {};
  responseStore: any;
  isChangeCoordinates: boolean = false;
  goBackUrl: string = "/store/store";
  ckeConfig: any;
  storeDescriptionValue: string;
  storeManagerBiographyValue: string;
  @ViewChild("ckeditor") ckeditor: any;
  isButtonSaveDisabled: boolean = false;
  originalPubValue: boolean;


  initialGalleryIdsValue = new FormControl('');
  initialInternalGalleryIdsValue = new FormControl('');
  initialDocumentValue = new FormControl('');



  //Hours view
  standardHours: OpeningClosingHoursResponse = new OpeningClosingHoursResponse();

  //System View
  systemView: any = {
    createdAt: "",
    createdBy: "",
    modifiedAt: "",
    modifiedBy: ""
  }

  //Published View
  publishedView: any = {
    published: true
  }




  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private routerExt: RouteExtService,
    private storeService: StoreService,
    private openingClosingHoursService: OpeningClosingHoursService,
    private galleryService: GalleryService,
    private storeAccessoryService: StoreAccessoryService,
    private productServiceService: ProductServiceService,
    private promotionEventService: PromotionEventService,
    private imageService: ImageService,
    private documentService: DocumentService,
    private fb: FormBuilder,
    private modalService: NgbModal,
    public domSanitizer: DomSanitizer,
    private toastr: ToastrService,
    private spinner: SpinnerService,
    private utilsService: UtilsService
  ) {
    this.id = this.route.snapshot.params['id'];
    this.ckeConfig = this.utilsService.configCkeditor;
    this.initForm();
    this.standardHours = new OpeningClosingHoursResponse();
    this.manageTabs();
  }

  ngOnInit(): void {
    this.manageTabs();
    this.loadDataByID(this.id);
    this.loadHourByID(this.id);
  }

  manageTabs() {
    this.route.fragment.subscribe((fragment: string) => {
      this.changeTabs(fragment);
    })
  }

  changeTabs(value: string) {
    let nessuno = true;
    if (value != null && typeof value != typeof undefined) {
      if ('store' === value.toLowerCase()) { this.tabs.store = 'active'; nessuno = false; } else { this.tabs.store = ''; }
      if ('location' === value.toLowerCase()) { this.tabs.location = 'active'; nessuno = false; } else { this.tabs.location = ''; }
      if ('storemanager' === value.toLowerCase()) { this.tabs.storemanager = 'active'; nessuno = false; } else { this.tabs.storemanager = ''; }
      if ('flags' === value.toLowerCase()) { this.tabs.flags = 'active'; nessuno = false; } else { this.tabs.flags = ''; }
    }
    if (nessuno === TRUE) { this.tabs.store = 'active'; }
  }

  get form() { return this.formBuilder; }
  get formControls() { return this.formBuilder.controls; }
  get location() { return this.formBuilder.get("location"); }
  get locationControls() {
    let location = this.formBuilder.get("location");
    let controls = location["controls"];
    return controls;
  }
  get embeddedStoreManager() { return this.formBuilder.get("embeddedStoreManager"); }
  get embeddedStoreManagerControls() {
    let embedded = this.formBuilder.get("embeddedStoreManager");
    let controls = embedded["controls"];
    return controls;
  }
  get visibilityFlag() { return this.formBuilder.get("visibilityFlag"); }
  get visibilityFlagControls() {
    let visibilityFlag = this.formBuilder.get("visibilityFlag");
    let controls = visibilityFlag["controls"];
    return controls;
  }


  loadDataByID(idObj) {
    this.storeService.getEntity(idObj).subscribe(
      (response) => {
        if (response) {
          this.responseStore = response;
          this.titleStore = response.location.address.toUpperCase() + " - " + response.location.normalizedZip + " " + response.location.normalizedCity + " (" + response.location.province + ")";
          this.pageUrl = this.fe_url + "it/" + response.seoId + "/";
          this.setFormValue(response);
        }
        this.spinner.hide();
      },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.toastr.error('Si è verificato un errore durante il caricamento delle informazioni dello Store', 'Load Store', {
          timeOut: 5000
        });
        this.spinner.hide();
      }
    );
  }

  loadHourByID(idObj) {
    let request = new OpeningClosingHoursRequestSearch();
    request.pageNumber = 0;
    request.pageSize = 10;
    request.storeId = idObj;
    request.type = OpeningClosingHoursType.STANDARD;
    this.openingClosingHoursService.search(request).subscribe(
      (response) => {
        if (response) {
          this.standardHours = response.data[0];
        }
        this.spinner.hide();
      },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.toastr.error('Si è verificato un errore durante il caricamento delle informazioni dello Store', 'Load Store', {
          timeOut: 5000
        });
        this.spinner.hide();
      }
    );
  }

  initForm() {
    this.storeDescriptionValue = '';
    this.storeManagerBiographyValue = '';
    this.formBuilder = this.fb.group({
      chainOfStores: [{ value: '', disabled: true }],
      comsy: [{ value: '', disabled: true }],
      dealerCategory: [{ value: '', disabled: true }],
      dealerDescription: [{ value: '', disabled: true }],
      email: [{ value: '', disabled: true }],
      facebookLink: [''],
      googlePlace: [{ value: '', disabled: true }],
      googlePlus: [{ value: '', disabled: true }],
      hasEquipmentWithdrawalExcluded: [{ value: true, disabled: true }],
      findomesticMonthlyPaymentFw: [{ value: false, disabled: true }],
      findomesticStatus: [{ value: false, disabled: true }],
      messengerLink: [''],
      posId: [''],
      posIdParent: [''],
      published: [true],
      resellerLink: [{ value: '', disabled: true }],
      reservationLink: [''],
      seoDescription: [''],
      seoId: [''],
      storeDescription: [''],
      telephone: [{ value: '', disabled: true }],
      title: [''],
      titleSeo: [''],
      whatsapp: [''],
      whatsappAddress: [''],
      headImageId: [],
      documentIds: [],
      galleryIds: [[]],
      internalGalleryIds: [[]],
      productAndServices: [[]],
      promozioneEventi: [[]],
      location: this.initFormLocationStore(),
      embeddedStoreManager: this.initFormEmbeddedStoreManager(),
      visibilityFlag: this.initFormVisibilityFlag()
    });
  }

  initFormLocationStore() {
    let form = this.fb.group({
      accuracy: [{ value: '', disabled: true }],
      address: [{ value: '', disabled: true }],
      city: [{ value: '', disabled: true }],
      province: [{ value: '', disabled: true }],
      region: [{ value: '', disabled: true }],
      zip: [{ value: '', disabled: true }],

      fullNormalizedAddress: [{ value: '', disabled: true }],
      latitude: [{ value: '', disabled: true }],
      longitude: [{ value: '', disabled: true }],
      normalizedAddress: [{ value: '', disabled: true }],
      normalizedCity: [{ value: '', disabled: true }],
      normalizedCountry: [{ value: '', disabled: true }],
      normalizedDug: [{ value: '', disabled: true }],
      normalizedHamlet: [{ value: '', disabled: true }],
      normalizedHouseNumber: [{ value: '', disabled: true }],
      normalizedLatitude: [{ value: '', disabled: false }],
      normalizedLongitude: [{ value: '', disabled: false }],
      normalizedProvince: [{ value: '', disabled: true }],
      normalizedRegion: [{ value: '', disabled: true }],
      normalizedZip: [{ value: '', disabled: true }],
      streetViewPanoId: [{ value: '', disabled: true }],
      streetViewEnabled: [{ value: '', disabled: true }],
      streetViewHeading: [{ value: '', disabled: true }],
      streetViewLatitude: [{ value: '', disabled: true }],
      streetViewLongitude: [{ value: '', disabled: true }],
      streetViewPitch: [{ value: '', disabled: true }],
      streetViewZoom: [{ value: '', disabled: true }],
    });
    return form;
  }

  initFormEmbeddedStoreManager() {
    let form = this.fb.group({
      storeManagerAlternativeEmail1: ['', [Validators.email]],
      storeManagerAlternativeEmail2: ['', [Validators.email]],
      storeManagerBiography: [''],
      storeManagerEmail: ['', [Validators.email]],
      storeManagerGoogleProfile: [''],
      storeManagerName: [''],
      storeManagerSurname: [''],
      storeManagerTelephone: [''],
      storeManagerEmailXml: ['']
    });
    form.controls.storeManagerEmailXml.disable();
    return form;
  }

  initFormVisibilityFlag() {
    let form = this.fb.group(new VisibilityFlag());
    return form;
  }

  getFormValue() {
    let request = new StoreRequest();
    request.chainOfStores = this.formBuilder.controls['chainOfStores'].value;
    request.dealerCategory = this.formBuilder.controls['dealerCategory'].value;
    request.dealerDescription = this.formBuilder.controls['dealerDescription'].value;
    request.email = this.formBuilder.controls['email'].value;
    request.facebookLink = this.formBuilder.controls['facebookLink'].value;
    request.googlePlace = this.formBuilder.controls['googlePlace'].value;
    request.googlePlus = this.formBuilder.controls['googlePlus'].value;
    request.hasEquipmentWithdrawalExcluded = this.formBuilder.controls['hasEquipmentWithdrawalExcluded'].value;
    request.findomesticMonthlyPaymentFw = this.formBuilder.controls['findomesticMonthlyPaymentFw'].value;
    request.findomesticStatus = this.formBuilder.controls['findomesticStatus'].value;
    request.messengerLink = this.formBuilder.controls['messengerLink'].value;
    request.posId = this.formBuilder.controls['posId'].value;
    request.posIdParent = this.formBuilder.controls['posIdParent'].value;
    request.resellerLink = this.formBuilder.controls['resellerLink'].value;
    request.reservationLink = this.formBuilder.controls['reservationLink'].value;
    request.seoDescription = this.formBuilder.controls['seoDescription'].value;
    request.seoId = this.formBuilder.controls['seoId'].value;
    request.storeDescription = this.storeDescriptionValue;
    request.telephone = this.formBuilder.controls['telephone'].value;
    request.title = this.formBuilder.controls['title'].value;
    request.titleSeo = this.formBuilder.controls['titleSeo'].value;
    request.whatsapp = this.formBuilder.controls['whatsapp'].value;
    request.whatsappAddress = this.formBuilder.controls['whatsappAddress'].value;




    let productServices = this.getProductServices();
    if (productServices != null) {
      request.productServices = productServices;
    } else {
      request.productServices = [];
    }

    let promotionEvents = this.getPromotionEvents();
    if (promotionEvents != null) {
      request.promotionEvents = promotionEvents;
    } else {
      request.promotionEvents = [];
    }
    let galleries = this.getGalleries();
    if (galleries != null) {
      request.galleries = galleries;
    } else {
      request.galleries = [];
    }

    let internalGalleries = this.getInternalGalleries();
    if (internalGalleries != null) {
      request.internalGalleries = internalGalleries;
    } else {
      request.internalGalleries = [];
    }

    let storeAccesories = this.getStoreAccesories();
    if (storeAccesories != null) {
      request.storeAccesories = storeAccesories;
    } else {
      request.storeAccesories = [];
    }

    let documents = this.getDocuments();
    if (documents != null) {
      request.documents = documents;
    } else {
      request.documents = [];
    }

    request.headImageId = this.formBuilder.controls['headImageId'].value;
    request.published = this.formBuilder.controls['published'].value;
    request.location = this.getFormLocation();
    request.embeddedStoreManager = this.getFormEmbeddedStoreManager();
    request.visibilityFlag = this.getFormVisibilityFlag();
    return request;
  }

  getFormLocation() {
    let request = new LocationStore();
    request.accuracy = this.locationControls['accuracy'].value;
    request.address = this.locationControls['address'].value;
    request.city = this.locationControls['city'].value;
    request.fullNormalizedAddress = this.locationControls['fullNormalizedAddress'].value;
    request.latitude = this.locationControls['latitude'].value;
    request.longitude = this.locationControls['longitude'].value;
    request.normalizedAddress = this.locationControls['normalizedAddress'].value;
    request.normalizedCity = this.locationControls['normalizedCity'].value;
    request.normalizedCountry = this.locationControls['normalizedCountry'].value;
    request.normalizedDug = this.locationControls['normalizedDug'].value;
    request.normalizedHamlet = this.locationControls['normalizedHamlet'].value;
    request.normalizedHouseNumber = this.locationControls['normalizedHouseNumber'].value;
    request.normalizedProvince = this.locationControls['normalizedProvince'].value;
    request.normalizedRegion = this.locationControls['normalizedRegion'].value;
    request.normalizedZip = this.locationControls['normalizedZip'].value;
    request.normalizedLatitude = this.locationControls['normalizedLatitude'].value;
    request.normalizedLongitude = this.locationControls['normalizedLongitude'].value;
    request.province = this.locationControls['province'].value;
    request.region = this.locationControls['region'].value;
    request.streetViewPanoId = this.locationControls['streetViewPanoId'].value;
    request.streetViewEnabled = this.locationControls['streetViewEnabled'].value;
    request.streetViewHeading = this.locationControls['streetViewHeading'].value;
    request.streetViewLatitude = this.locationControls['streetViewLatitude'].value;
    request.streetViewLongitude = this.locationControls['streetViewLongitude'].value;
    request.streetViewPitch = this.locationControls['streetViewPitch'].value;
    request.streetViewZoom = this.locationControls['streetViewZoom'].value;
    request.zip = this.locationControls['zip'].value;

    if (request.normalizedLatitude.trim() != this.responseStore.location.normalizedLatitude.trim() ||
      request.normalizedLongitude.trim() != this.responseStore.location.normalizedLongitude.trim()) {
      request.accuracy = "M";
    }

    return request;
  }

  getFormEmbeddedStoreManager() {
    let request = new EmbeddedStoreManager();
    request.storeManagerAlternativeEmail1 = this.embeddedStoreManagerControls['storeManagerAlternativeEmail1'].value;
    request.storeManagerAlternativeEmail2 = this.embeddedStoreManagerControls['storeManagerAlternativeEmail2'].value;
    request.storeManagerBiography = this.storeManagerBiographyValue;
    request.storeManagerEmail = this.embeddedStoreManagerControls['storeManagerEmail'].value;
    request.storeManagerGoogleProfile = this.embeddedStoreManagerControls['storeManagerGoogleProfile'].value;
    request.storeManagerName = this.embeddedStoreManagerControls['storeManagerName'].value;
    request.storeManagerSurname = this.embeddedStoreManagerControls['storeManagerSurname'].value;
    request.storeManagerTelephone = this.embeddedStoreManagerControls['storeManagerTelephone'].value;
    return request;
  }

  getFormVisibilityFlag() {
    let request = new VisibilityFlag();
    request.visibilityClickAndCollectSim = this.visibilityFlagControls['visibilityClickAndCollectSim'].value;
    request.visibilityClickAndCollectSmartphone = this.visibilityFlagControls['visibilityClickAndCollectSmartphone'].value;
    request.visibilityEmail = this.visibilityFlagControls['visibilityEmail'].value;
    request.visibilityEvent = this.visibilityFlagControls['visibilityEvent'].value;
    request.visibilityFacebook = this.visibilityFlagControls['visibilityFacebook'].value;
    request.visibilityFullStoreDescription = this.visibilityFlagControls['visibilityFullStoreDescription'].value;
    request.visibilityGallery = this.visibilityFlagControls['visibilityGallery'].value;
    request.visibilityGooglePlace = this.visibilityFlagControls['visibilityGooglePlace'].value;
    request.visibilityInternalGallery = this.visibilityFlagControls['visibilityInternalGallery'].value;
    request.visibilityManageOpeningClosingTime = this.visibilityFlagControls['visibilityManageOpeningClosingTime'].value;
    request.visibilityManageOpeningClosingTimeAppointments = this.visibilityFlagControls['visibilityManageOpeningClosingTimeAppointments'].value;
    request.visibilityOpeningClosingTime = this.visibilityFlagControls['visibilityOpeningClosingTime'].value;
    request.visibilityPromotion = this.visibilityFlagControls['visibilityPromotion'].value;
    request.visibilityScheduleAppointments = this.visibilityFlagControls['visibilityScheduleAppointments'].value;
    request.visibilityServices = this.visibilityFlagControls['visibilityServices'].value;
    request.visibilityStoreManager = this.visibilityFlagControls['visibilityStoreManager'].value;
    request.visibilityStoreManagerEmail = this.visibilityFlagControls['visibilityStoreManagerEmail'].value;
    request.visibilityStoreManagerPhoto = this.visibilityFlagControls['visibilityStoreManagerPhoto'].value;
    request.visibilityStoreManagerTelephone = this.visibilityFlagControls['visibilityStoreManagerTelephone'].value;
    request.visibilityTelephone = this.visibilityFlagControls['visibilityTelephone'].value;
    request.visibilityVideocallme = this.visibilityFlagControls['visibilityVideocallme'].value;
    request.visibilityDigitalCoupon = this.visibilityFlagControls['visibilityDigitalCoupon'].value;
    return request;
  }






  setFormValue(response) {

    let tmpfindomesticStatus = false;
    if (response.findomesticStatus !== null) {
      tmpfindomesticStatus = response.findomesticStatus;
    }

    let tmpfindomesticMonthlyPaymentFw = false;
    if (response.findomesticMonthlyPaymentFw !== null) {
      tmpfindomesticMonthlyPaymentFw = response.findomesticMonthlyPaymentFw;
    }


    this.formBuilder = this.fb.group({
      chainOfStores: [{ value: response.chainOfStores, disabled: true }],
      comsy: [{ value: response.comsy, disabled: true }],
      dealerCategory: [{ value: response.dealerCategory, disabled: true }],
      dealerDescription: [{ value: response.dealerDescription, disabled: true }],
      email: [{ value: response.email, disabled: true }],
      googlePlace: [{ value: response.googlePlace, disabled: true }],
      googlePlus: [{ value: response.googlePlus, disabled: true }],
      hasEquipmentWithdrawalExcluded: [{ value: response.hasEquipmentWithdrawalExcluded, disabled: true }],
      findomesticMonthlyPaymentFw: [{ value: tmpfindomesticMonthlyPaymentFw, disabled: true }],
      findomesticStatus: [{ value: tmpfindomesticStatus, disabled: true }],
      resellerLink: [{ value: response.resellerLink, disabled: true }],
      telephone: [{ value: response.telephone, disabled: true }],

      facebookLink: [''],
      messengerLink: [''],
      posId: [''],
      posIdParent: [''],
      published: [true],
      reservationLink: [''],
      seoId: [''],
      seoDescription: [''],
      storeDescription: [''],
      title: [''],
      titleSeo: [''],
      whatsapp: [''],
      whatsappAddress: [''],
      headImageId: [],
      documentIds: [],
      galleryIds: [[]],
      internalGalleryIds: [[]],
      productAndServices: [[]],
      promozioneEventi: [[]],
      location: this.setFormLocation(response.location),
      embeddedStoreManager: this.setFormEmbeddedStoreManager(response.embeddedStoreManager),
      visibilityFlag: this.setFormVisibilityFlag(response.visibilityFlag)
    });

    this.formBuilder.controls['storeDescription'].setValue(response.storeDescription);
    this.formBuilder.controls['seoId'].setValue(response.seoId);
    this.formBuilder.controls['titleSeo'].setValue(response.titleSeo);
    this.formBuilder.controls['seoDescription'].setValue(response.seoDescription);
    this.formBuilder.controls['facebookLink'].setValue(response.facebookLink);
    this.formBuilder.controls['resellerLink'].setValue(response.resellerLink);
    this.formBuilder.controls['reservationLink'].setValue(response.reservationLink);
    this.formBuilder.controls['whatsapp'].setValue(response.whatsapp);
    this.formBuilder.controls['whatsappAddress'].setValue(response.whatsappAddress);
    this.formBuilder.controls['messengerLink'].setValue(response.messengerLink);


    this.formBuilder.controls['posId'].setValue(response.posId);
    this.formBuilder.controls['posIdParent'].setValue(response.posIdParent);
    this.formBuilder.controls['published'].setValue(response.published);
    this.originalPubValue = response.published;
    this.formBuilder.controls['title'].setValue(response.title);

    //Ck Editor
    this.storeDescriptionValue = this.formBuilder.controls['storeDescription'].value;



    if (response.headImageId != null) {
      this.formBuilder.controls['headImageId'].setValue(response.headImageId.id);
      this.loadImage(response.headImageId.id);
    }
    if (response.documents) {
      this.selectEventFromResponse_documentIds(response.documents);
      this.initialDocumentValue = new FormControl(response.documents[0].name);
    }


    this.setProductServices(response.productAndServices);
    this.setPromotionEvents(response.promotionEvents);

    if (response.galleries) {
      this.selectEventFromResponse_galleryIds(response.galleries)
      this.initialGalleryIdsValue = new FormControl(response.galleries[0].name);
    }


    if (response.internalGalleries) {
      this.selectEventFromResponse_internalGalleryIds(response.internalGalleries)
      this.initialInternalGalleryIdsValue = new FormControl(response.internalGalleries[0].name);
    }

    this.setStoreAccesories(response.storeAccesories);

    this.setSystemView(response);
    this.setPublishedView(response);

  }

  setSystemView(response) {
    this.systemView = {
      createdAt: response.createdAt,
      createdBy: response.createdBy,
      modifiedAt: response.modifiedAt,
      modifiedBy: response.modifiedBy
    };
  }

  setPublishedView(response) {
    this.publishedView.published = response.published;
  }

  setFormLocation(location) {
    let form = this.initFormLocationStore();
    form = this.copyValuesResponseIntoForm(form, location);
    return form;
  }

  setFormEmbeddedStoreManager(embeddedStoreManager) {
    let form = this.initFormEmbeddedStoreManager();
    if (embeddedStoreManager != null && typeof embeddedStoreManager != typeof undefined) {
      form.controls['storeManagerAlternativeEmail1'].setValue(embeddedStoreManager.storeManagerAlternativeEmail1);
      form.controls['storeManagerAlternativeEmail2'].setValue(embeddedStoreManager.storeManagerAlternativeEmail2);
      form.controls['storeManagerBiography'].setValue(embeddedStoreManager.storeManagerBiography);
      form.controls['storeManagerEmail'].setValue(embeddedStoreManager.storeManagerEmail);
      form.controls['storeManagerEmailXml'].setValue(embeddedStoreManager.storeManagerEmailXml);
      form.controls['storeManagerGoogleProfile'].setValue(embeddedStoreManager.storeManagerGoogleProfile);
      form.controls['storeManagerName'].setValue(embeddedStoreManager.storeManagerName);
      form.controls['storeManagerSurname'].setValue(embeddedStoreManager.storeManagerSurname);
      form.controls['storeManagerTelephone'].setValue(embeddedStoreManager.storeManagerTelephone);
    }
    this.storeManagerBiographyValue = form.controls['storeManagerBiography'].value;
    return form;
  }

  setFormVisibilityFlag(visibilityFlag) {
    let form = this.initFormVisibilityFlag();
    form = this.copyValuesResponseIntoForm(form, visibilityFlag);
    return form;
  }

  copyValuesResponseIntoForm(form, response) {
    for (let attr in response) {
      if (typeof form.controls[attr] != typeof undefined) {
        form.controls[attr].setValue(response[attr]);
      } else {
        console.log(attr);
      }
    }
    return form;
  }

  changeCoordinates() {
    let lat = this.locationControls['normalizedLatitude'].value;
    let long = this.locationControls['normalizedLongitude'].value;
    if (lat.trim() != this.responseStore.location.normalizedLatitude.trim() ||
      long.trim() != this.responseStore.location.normalizedLongitude.trim()) {
      this.locationControls['accuracy'].setValue("M");
      this.isChangeCoordinates = true;
    }
  }
  resetCoordinates() {
    this.locationControls['normalizedLatitude'].setValue(this.responseStore.location.normalizedLatitude);
    this.locationControls['normalizedLongitude'].setValue(this.responseStore.location.normalizedLongitude);
    this.locationControls['accuracy'].setValue(this.responseStore.location.accuracy);
    this.isChangeCoordinates = false;
  }

  modifyCoordinates() {
    //Apre modale selezione 
    const modalRef = this.modalService.open(ChoicePositionmapModalComponent, DIALOG_LARGE_CONFIG);
    modalRef.componentInstance.name_store = this.titleStore;
    modalRef.componentInstance.dealer_store = this.responseStore.dealerCategory;
    modalRef.componentInstance.lat = parseFloat(this.locationControls['normalizedLatitude'].value);
    modalRef.componentInstance.lng = parseFloat(this.locationControls['normalizedLongitude'].value);
    modalRef.result.then(result => {
      if (result && result != "CLOSE") {
        this.locationControls['normalizedLatitude'].setValue(result.lat.toString());
        this.locationControls['normalizedLongitude'].setValue(result.lng.toString());
        this.changeCoordinates();
        this.change(null);
      }
    });
  }


  change(event) {
    this.form.markAsTouched();
  }

  save() {
    this.request = this.getFormValue();
    this.spinner.show();
    this.storeService.update(this.id, this.request).subscribe(
      (response) => {
        if (response) {
          //Salvata modifica
          this.toastr.success('Store modificato con successo', 'Modifica Store', {
            timeOut: 5000
          });
          if (this.originalPubValue != this.request.published) {
            this.publish();
          } else {
            this.clickButtonGoBack();
          }
        }
        this.isButtonSaveDisabled = false;
        this.spinner.hide();
      },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.toastr.error('Si è verificato un errore durante la modifica dello Store', 'Modifica Store', {
          timeOut: 5000
        });
        this.isButtonSaveDisabled = false;
        this.spinner.hide();
      }
    );

  }

  clickButtonSave() {
    if (this.formBuilder.status === 'VALID') {
      this.isButtonSaveDisabled = true;
      this.save();
    }
  }

  clickButtonGoBack() {
    let previousUrl = this.routerExt.getPreviousUrl();
    if (previousUrl === this.routerExt.getCurrentUrl() || !previousUrl) {
      this.router.navigate([this.goBackUrl])
    } else {
      this.router.navigate([previousUrl]);
    }
  }


  //Autocomplete - galleryIds <- Galleria immagini
  @ViewChild('galleryIds') galleryIds;
  galleryIds_Keyword = 'name';
  galleryIds_Suggestion: any = [];
  galleryIdsSelected: any = [];
  errorMsg: string;
  isGalleryIdsKeywordLoadingResult: boolean;
  getGalleryIdsRequest(event) {
    let request = new GalleryRequestSearch();
    request.name = event;
    request.published = true;
    request.pageNumber = 0;
    request.pageSize = 20;
    return request;
  }
  fill_galleryIds_Suggestion(response) {
    for (let obj of response.data) {
      let trovato = false;
      for (let j = 0; j < this.galleryIdsSelected.length && !trovato; j++) {
        if (obj.id == this.galleryIdsSelected[j].id) {
          trovato = true;
        }
      }
      if (!trovato) {
        this.galleryIds_Suggestion.push(obj);
      }
    }
  }
  getList_galleryIds(event) {
    this.detectFormChange();
    this.isGalleryIdsKeywordLoadingResult = true;
    let request = this.getGalleryIdsRequest(event);
    this.galleryService.search(request).subscribe(response => {
      this.galleryIds_Suggestion = [];
      if (response != null && typeof response != typeof undefined) {
        //aggiungo elementi nella suggestion
        this.fill_galleryIds_Suggestion(response);
      }
      this.isGalleryIdsKeywordLoadingResult = false;
    });
  }
  searchGalleryIdsCleared() {
    this.detectFormChange();

    this.galleryIds_Suggestion = [];
    this.galleryIdsSelected = [];
  }
  selectEvent_galleryIds(item) {
    this.galleryIdsSelected.push(item);
  }
  selectEventFromResponse_galleryIds(item) {
    this.galleryIdsSelected = item;
  }
  onChangeSearch(val: string) {
    // fetch remote data from here
    // And reassign the 'data' which is binded to 'data' property.
  }
  onFocused_GalleryIds(e) {
    console.log(e);
    this.getList_galleryIds("");
  }
  /*
  //Chip list - galleryIds <- Galleria immagini
  labelKeysGalleryIds = ["name"];
  onChangeItemListGalleryIdsSelected($event) {
    console.log($event);
  }*/

  getGalleries() {

    let res = null;
    if (this.galleryIdsSelected.length > 0) {
      res = [];
      for (let obj of this.galleryIdsSelected) {
        res.push(obj.id);
      }
    }
    return res;
  }
  setGalleries(value) {
    if (value != null) {
      this.galleryIdsSelected.push(value[0]);
    }
  }



  //Autocomplete - internalGalleryIds <- Galleria interna immagini
  @ViewChild('internalGalleryIds') internalGalleryIds;
  internalGalleryIds_Keyword = 'name';
  internalGalleryIds_Suggestion: any = [];
  internalGalleryIdsSelected: any = [];
  errorMsgInternalGalleryIds: string;
  isInternalGalleryIdsKeywordLoadingResult: boolean;
  fill_internalGalleryIds_Suggestion(response) {
    for (let obj of response.data) {
      let trovato = false;
      for (let j = 0; j < this.internalGalleryIdsSelected.length && !trovato; j++) {
        if (obj.id == this.internalGalleryIdsSelected[j].id) {
          trovato = true;
        }
      }
      if (!trovato) {
        this.internalGalleryIds_Suggestion.push(obj);
      }
    }
  }
  getList_internalGalleryIds(event) {
    this.detectFormChange();
    this.isInternalGalleryIdsKeywordLoadingResult = true;
    let request = new GalleryRequestSearch();
    request.name = event;
    request.published = true;
    request.pageNumber = 0
    request.pageSize = 20
    this.galleryService.search(request).subscribe(response => {
      this.internalGalleryIds_Suggestion = [];
      if (response != null && typeof response != typeof undefined) {
        //aggiungo elementi nella suggestion
        this.fill_internalGalleryIds_Suggestion(response);
      }
      this.isInternalGalleryIdsKeywordLoadingResult = false;
    });
  }
  searchInternalGalleryIdsCleared() {
    this.detectFormChange();

    this.internalGalleryIds_Suggestion = [];
    this.internalGalleryIdsSelected = [];
  }
  selectEvent_internalGalleryIds(item) {
    this.internalGalleryIdsSelected.push(item);
  }
  selectEventFromResponse_internalGalleryIds(item) {
    this.internalGalleryIdsSelected = item;
  }
  onFocused__InternalGalleryIds(e) {
    console.log(e);
    this.getList_internalGalleryIds("");
  }
  /*
  //Chip list - internalGalleryIds <- Galleria interna immagini
  labelKeysInternalGalleryIds = ["name"];
  onChangeItemListInternalGalleryIds($event) {
    console.log($event);
  }*/

  getInternalGalleries() {
    let res = null;
    if (this.internalGalleryIdsSelected.length > 0) {
      res = [];
      for (let obj of this.internalGalleryIdsSelected) {
        res.push(obj.id);
      }
    }
    return res;
  }
  setInternalGalleries(value) {
    if (value != null) {
      this.internalGalleryIdsSelected = value;
    }
  }






  //Autocomplete - accessoryIds  <- Lista comodità cliente in negozio
  @ViewChild('accessoryIds ') accessoryIds;
  accessoryIds_Keyword = 'name';
  accessoryIds_Suggestion: any = [];
  accessoryIds_Selected: any = [];
  accessoryIds_errorMsg: string;
  accessoryIds_isKeywordLoadingResult: boolean;
  getFilter_accessoryIds(event) {
    let request = new StoreAccessoryRequestSearch();
    request.name = event;
    request.published = true;
    request.pageNumber = 0
    request.pageSize = 20
    return request
  }
  fill_accessoryIds_Suggestion(response) {
    for (let obj of response.data) {
      let trovato = false;
      for (let j = 0; j < this.accessoryIds_Selected.length && !trovato; j++) {
        if (obj.id == this.accessoryIds_Selected[j].id) {
          trovato = true;
        }
      }
      if (!trovato) {
        this.accessoryIds_Suggestion.push(obj);
      }
    }
  }
  getList_accessoryIds(event) {
    this.detectFormChange();
    this.accessoryIds_isKeywordLoadingResult = true;
    let request = this.getFilter_accessoryIds(event);
    this.storeAccessoryService.search(request).subscribe(response => {
      this.accessoryIds_Suggestion = [];
      if (response != null && typeof response != typeof undefined) {
        //aggiungo elementi nella suggestion
        this.fill_accessoryIds_Suggestion(response);
      }
      this.accessoryIds_isKeywordLoadingResult = false;
    });
  }
  searchCleared__accessoryIds() {
    this.detectFormChange();

    this.accessoryIds_Suggestion = [];
  }
  selectEvent__accessoryIds(item) {
    this.accessoryIds_Selected.push(item);
    this.accessoryIds.clear();
  }
  onFocused__accessoryIds(e) {
    console.log(e);
    this.getList_accessoryIds("");
    // do something when input is focused
  }
  //Chip list - accessoryIds <- Galleria interna immagini
  labelKeys_accessoryIds = ["name"];
  onChangeItemList_accessoryIds($event) {
    console.log($event);
  }
  getStoreAccesories() {
    let res = null;
    if (this.accessoryIds_Selected.length > 0) {
      res = [];
      for (let obj of this.accessoryIds_Selected) {
        res.push(obj.id);
      }
    }
    return res;
  }
  setStoreAccesories(value) {
    if (value != null) {
      this.accessoryIds_Selected = value;
    }
  }




  //Autocomplete - productAndServices  <- Prodotti e Servizi
  @ViewChild('productAndServices ') productAndServices;
  productAndServices_Keyword = 'serviceName';
  productAndServices_Suggestion: any = [];
  productAndServices_Selected: any = [];
  productAndServices_errorMsg: string;
  productAndServices_isKeywordLoadingResult: boolean;

  getFilter_productAndServices(event) {
    let request = new ProductServiceRequestSearch();
    request.serviceName = event;
    request.published = true;
    request.pageNumber = 0
    request.pageSize = 20
    return request
  }
  fill_productAndServices_Suggestion(response) {
    for (let obj of response.data) {
      let trovato = false;
      for (let j = 0; j < this.productAndServices_Selected.length && !trovato; j++) {
        if (obj.id == this.productAndServices_Selected[j].id) {
          trovato = true;
        }
      }
      if (!trovato) {
        this.productAndServices_Suggestion.push(obj);
      }
    }
  }
  getList_productAndServices(event) {
    this.detectFormChange();
    this.productAndServices_isKeywordLoadingResult = true;
    let request = this.getFilter_productAndServices(event);
    this.productServiceService.search(request).subscribe(response => {
      this.productAndServices_Suggestion = [];
      if (response != null && typeof response != typeof undefined) {
        //aggiungo elementi nella suggestion
        this.fill_productAndServices_Suggestion(response);
      }
      this.productAndServices_isKeywordLoadingResult = false;
    });
  }
  searchCleared__productAndServices() {
    this.detectFormChange();

    this.productAndServices_Suggestion = [];
  }
  selectEvent__productAndServices(item) {
    this.productAndServices_Selected.push(item);
    this.productAndServices.clear();
  }
  onFocused__productAndServices(e) {
    console.log(e);
    this.getList_productAndServices("");
    // do something when input is focused
  }
  //Chip list - productAndServices <- Prodotti e Servizi
  labelKeys_productAndServices = ["serviceName"];
  onChangeItemList_productAndServices($event) {
    console.log($event);
  }

  getProductServices() {
    console.log(this.productAndServices_Selected);
    let res = null;
    if (this.productAndServices_Selected.length > 0) {
      res = [];
      for (let obj of this.productAndServices_Selected) {
        res.push(obj.id);
      }
    }
    return res;
  }
  setProductServices(value) {
    if (value != null) {
      this.productAndServices_Selected = value;
    }
  }



  //Autocomplete - promozioneEventi  <- Promozioni/Eventi
  @ViewChild('promozioneEventi ') promozioneEventi;
  promozioneEventi_Keyword = 'name';
  promozioneEventi_Suggestion: any = [];
  promozioneEventi_Selected: any = [];
  promozioneEventi_errorMsg: string;
  promozioneEventi_isKeywordLoadingResult: boolean;
  getFilter_promozioneEventi(event) {
    let request = new PromotionEventRequestSearch();
    request.name = event;
    request.published = true;
    request.pageNumber = 0
    request.pageSize = 20
    return request
  }

  fill_promozioneEventi_Suggestion(response) {
    for (let obj of response.data) {
      let trovato = false;
      for (let j = 0; j < this.promozioneEventi_Selected.length && !trovato; j++) {
        if (obj.id == this.promozioneEventi_Selected[j].id) {
          trovato = true;
        }
      }
      if (!trovato) {
        this.promozioneEventi_Suggestion.push(obj);
      }
    }
  }
  getList_promozioneEventi(event) {
    this.detectFormChange();
    this.promozioneEventi_isKeywordLoadingResult = true;
    let request = this.getFilter_promozioneEventi(event);
    this.promotionEventService.search(request).subscribe(response => {
      this.promozioneEventi_Suggestion = [];
      if (response != null && typeof response != typeof undefined) {
        //aggiungo elementi nella suggestion
        this.fill_promozioneEventi_Suggestion(response);
      }
      this.promozioneEventi_isKeywordLoadingResult = false;
    });
  }
  searchCleared__promozioneEventi() {
    this.detectFormChange();
    this.promozioneEventi_Suggestion = [];
  }
  selectEvent__promozioneEventi(item) {
    this.promozioneEventi_Selected.push(item);
    this.promozioneEventi.clear();
  }
  onFocused__promozioneEventi(e) {
    console.log(e);
    this.getList_promozioneEventi("");
    // do something when input is focused
  }
  //Chip list - promozioneEventi <- Promozioni/Eventi
  labelKeys_promozioneEventi = ["name"];
  onChangeItemList_promozioneEventi($event) {
    console.log($event);
  }

  getPromotionEvents() {
    let res = null;
    if (this.promozioneEventi_Selected.length > 0) {
      res = [];
      for (let obj of this.promozioneEventi_Selected) {
        res.push(obj.id);
      }
    }
    return res;
  }
  setPromotionEvents(value) {
    if (value != null) {
      this.promozioneEventi_Selected = value;
    }
  }





  //Autocomplete - documentIds  <- Documento
  @ViewChild('documentIds ') documentIds;
  documentIds_Keyword = 'name';
  documentIds_Suggestion: any = [];
  documentIds_Selected: any = [];
  documentIds_errorMsg: string;
  documentIds_isKeywordLoadingResult: boolean;
  getFilter_documentIds(event) {
    let request = new DocumentRequestSearch();
    request.name = event;
    request.published = true;
    request.pageNumber = 0
    request.pageSize = 20
    return request
  }
  fill_documentIds_Suggestion(response) {
    for (let obj of response.data) {
      let trovato = false;
      for (let j = 0; j < this.documentIds_Selected.length && !trovato; j++) {
        if (obj.id == this.documentIds_Selected[j].id) {
          trovato = true;
        }
      }
      if (!trovato) {
        this.documentIds_Suggestion.push(obj);
      }
    }
  }
  getList_documentIds(event) {
    this.detectFormChange();
    this.documentIds_isKeywordLoadingResult = true;
    let request = this.getFilter_documentIds(event);
    this.documentService.search(request).subscribe(response => {
      this.documentIds_Suggestion = [];
      if (response != null && typeof response != typeof undefined) {
        //aggiungo elementi nella suggestion
        this.fill_documentIds_Suggestion(response);
      }
      this.documentIds_isKeywordLoadingResult = false;
    });
  }
  searchCleared__documentIds() {
    this.detectFormChange();

    this.documentIds_Suggestion = [];
    this.documentIds_Selected = [];
  }

  selectEvent__documentIds(item) {
    this.documentIds_Selected.push(item);
  }

  selectEventFromResponse_documentIds(item) {
    this.documentIds_Selected = item;
  }

  onFocused__documentIds(e) {
    console.log(e);
    this.getList_documentIds("");
    // do something when input is focused
  }

  getDocuments() {
    let res = null;
    if (this.documentIds_Selected.length > 0) {
      res = [];
      for (let obj of this.documentIds_Selected) {
        res.push(obj.id);
      }
    }
    return res;
  }

  setDocuments(value) {
    if (value != null) {
      this.documentIds_Selected = value;
    }
  }





  //headImageId
  imageChoice: ImageResponseGet = new ImageResponseGet();
  visibleImageChoice: boolean = false;
  public imagesList: any = [];
  public imagesMapList: any = {};


  /** Azione click su button Carica da PC */
  openLoadImageFromPC() {
    //Apre modale di create
    const modalRef = this.modalService.open(ImmaginiCreateComponent, DIALOG_LARGE_CONFIG);
    modalRef.result.then(result => {
      if (result && result != "CLOSE") {
        let id = result.id;
        if (this.formBuilder.controls['headImageId'].value != parseInt(id)) {
          this.formBuilder.controls['headImageId'].setValue(id);
          this.formBuilder.controls['headImageId'].markAsTouched();
          this.loadImage(this.formBuilder.controls['headImageId'].value);
        }
      }
    });
  }



  /**  Azione click su button carica da D.A.M */
  openLoadImageFromDAM() {
    //Apertura modale di modifica 
    let value = this.formBuilder.controls['headImageId'].value;
    const modalRef = this.modalService.open(LoadImageFromDamComponent, DIALOG_LARGE_CONFIG);
    if (value == "" || value == null) {
      value = [];
    } else {
      value = [value];
    }
    modalRef.componentInstance.multiple = false;
    modalRef.componentInstance.idImages = value;
    modalRef.result.then((result: any) => {
      if (result && result != "CLOSE") {
        if (result.images.length > 0) {
          if (this.formBuilder.controls['headImageId'].value != parseInt(result.images[0].id)) {
            this.formBuilder.controls['headImageId'].setValue(result.images[0].id);
            this.formBuilder.controls['headImageId'].markAsTouched();
            this.loadImage(this.formBuilder.controls['headImageId'].value);
          }
        } else {
          this.imageChoice = this.imageChoice = new ImageResponseGet();
          this.visibleImageChoice = false;
          this.formBuilder.controls['headImageId'].setValue(null);
          this.formBuilder.controls['headImageId'].markAsTouched();
        }
      }
    });
  }

  deleteImage() {
    this.imageChoice = new ImageResponseGet();
    this.visibleImageChoice = false;
    this.formBuilder.controls['headImageId'].setValue(null);
    this.formBuilder.controls['headImageId'].markAsTouched();
  }

  loadImage(id) {
    this.visibleImageChoice = true;
    this.imageService.getEntity(id).subscribe(
      (response) => {
        this.insertImage(response);
      },
      (error) => {
        this.toastr.error('Si è verificato un errore durante il caricamento dell\'immagine', 'Caricamento immagine fallita', {
          timeOut: 5000
        });
      }
    );
  }

  insertImage(imageObj) {
    this.imageChoice = imageObj;
    let idImage = imageObj.id;
    if (imageObj.published === FALSE) {
      this.imageChoice.url = LOADINGIMAGE;
    }
    if (imageObj.published === FALSE) {
      this.downloadImage(idImage);
    }
  }
  /**
   * Carica immagine non pubblica
   * @param idImage 
   */
  downloadImage(idImage) {
    this.imageService.download(idImage).subscribe(
      (response) => {
        this.imageChoice.url = this.utilsService.getSecurityTrustURL(response);
      },
      (error: HttpErrorResponse) => {
        this.imageChoice.url = "/assets/images/no-image-icon.png";
      }
    );
  }

  detectFormChange() {
    this.form.markAsTouched();
  }

  getPubValue() {
    let request = this.formBuilder.controls['published'].value;
    return request;
  }

  publish() {
    this.request = this.getPubValue();
    this.storeService.publish(this.id, this.request).subscribe(
      (response) => {
        if (this.request == TRUE) {
          //Salvata modifica
          this.toastr.success('Store pubblicato con successo', 'Pubblica Store', {
            timeOut: 5000
          });
        } else {
          //Salvata modifica
          this.toastr.success('Store depubblicato con successo', 'Depubblica Store', {
            timeOut: 5000
          });
        }
        this.spinner.hide();
        this.clickButtonGoBack();
      },
      (error: HttpErrorResponse) => {
        if (this.request == TRUE) {
          this.toastr.error('Si è verificato un errore durante la pubblicazione dello Store ', 'Pubblica Store fallita', {
            timeOut: 5000
          });
        } else {
          this.toastr.error('Si è verificato un errore durante la depubblicazione dello Store ', 'Depubblica Store fallita', {
            timeOut: 5000
          });
        }
        console.log(error);
        this.spinner.hide();
      }
    );
  }

}
